import { useRouteError } from 'react-router-dom';

function ErrorPage() {
  const error = useRouteError();
console.log(error);
  let message = '';

  if (error.status === 500) {
    message = error.data.message;
  }

  if (error.status === 404) {
    message = 'Could not find resource or page.';
  }

  return (
      <div>
        <p>{message} {error.status}</p>
	  </div>
  );
}

export default ErrorPage;